import { setIsOpen } from './set-is-open/index.tsx';

export const actions = {
	setIsOpen,
} as const;
